export default {"src":"/_next/static/media/material-symbols_arrow-drop-down-rounded.f44607de.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};